import { useOthers } from '@liveblocks/react';

type Mutable<T> = {
  -readonly [K in keyof T]: T[K];
};

export const COLORS = ['#E57373', '#9575CD', '#4FC3F7', '#81C784', '#FF8A65', '#F06292', '#7986CB'];
export const useLiveCursors = () => {
  const others = useOthers();

  return (others || {}).reduce(
    (acc, current) => {
      const found = acc.find((item) => item.id === current.id);

      // If `id` already exists and the current `connectionId` is greater, replace it
      if (found) {
        if (current.connectionId > found.connectionId) {
          // eslint-disable-next-line no-param-reassign
          acc = acc.map((item) => (item.id === current.id ? current : item));
        }
      } else {
        // If `id` does not exist in the accumulator, add it
        acc.push(current);
      }

      return acc;
    },
    [] as Mutable<typeof others>
  );
};
